import { Service } from './service';

/**
 * @deprecated since version 1.4. use @Service
 */
export const Injectable: typeof Service = Service;
